import * as Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueRecaptcha from "vue3-recaptcha-v2";

import "@/assets/css/nprogress.css";
import "@/assets/css/main.css";

Vue.createApp(App)
  .use(router)
  .use(VueAxios, axios)
  .use(VueRecaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_SITEKEY,
    alterDomain: false,
  })
  .mount("#app");
